<template>
  <section id="works" class="works container main">
    <div class="wrapper main">
      <h2 class="left" data-aos="fade-up">
        <SvgTitle />
        <caption>MISSION LEADS IDEA</caption>
      </h2>
      <div class="grid-wrapper">
        <ul>
          <li v-for="item in Works" :key="item.index" data-aos="fade-up">
            <a @click="VidMount(item.id)">
              <img :src="require('@/assets/img/vid' + item.index + '.jpg')" alt="WORKS 01" />
              <h5>{{item.title}}</h5>
              <p v-if="item.text !== ''" v-html="item.text"></p>
            </a>
          </li>
        </ul>
        <!--<ComingSoon data-aos="fade-up" />-->
      </div>
    </div>
    <div id="video-container" v-if="VideoOnModal">
      <div class="inner">
        <youtube :video-id="VidID" ref="youtube" :player-vars="player"></youtube>
      </div>
      <div class="cover" @click="VidMount()" />
    </div>
  </section>
</template>

<script>
import SvgTitle from "@/assets/icon/h2/works.svg?inline";
import ComingSoon from "@/assets/icon/coming-soon.svg?inline";

export default {
  name: "section-works",
  components: {
    SvgTitle,
    ComingSoon
  },
  data() {
    return {
      VideoOnModal: false,
      VidID: "",
      player: {
        autoplay: 1
      },
      Works: [
        {
          index: "07",
          title: "笹嶋工業TV-CM",
          text: "",
          id: "F1OG7yQmhig"
        },
        {
          index: "08",
          title: "米田木材WEBムービー",
          text: "",
          id: "OIu3BwI5ieg"
        },
        {
          index: "09",
          title: "本堂精工TV-CM",
          text: "",
          id: "aPx6oK9uS_w"
        },
        {
          index: "06",
          title: "辰口温泉TV-CM",
          text: "",
          id: "2D0cizEnUnk"
        },
        {
          index: "03",
          title: "焼肉KUU TV-CM",
          text: "",
          id: "Rdl1h49aHDg"
        },
        {
          index: "04",
          title: "ファーストバンクTV-CM",
          text: "",
          id: "b5wp2t7OcM8"
        },
        {
          index: "05",
          title: "PC CARE TV-CM",
          text: "",
          id: "6gdkoPo3xSE"
        },
        {
          index: "01",
          title: "砺波工業TV-CM",
          text: "",
          id: "Grmt0CkN-5U"
        },
        {
          index: "02",
          title: "コマツ氷見工場TV-CM",
          text: "",
          id: "-FyjdzGf5EE"
        }
      ]
    };
  },
  methods: {
    VidMount(id) {
      this.VidID = id;
      this.VideoOnModal = !this.VideoOnModal;
    }
  }
};
</script>

<style lang="scss">
#video-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
  z-index: 2;
  .inner {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-content: center;
    width: auto;
    max-width: 640px;
    z-index: 1;
    margin: 0 auto;
    background: #000;
    @media #{$maxS} {
      width: 100%;
    }
    iframe {
      display: block;
      margin: 0 auto;
      max-width: 100%;
      @media #{$maxS} {
        width: 100%;
        height: calc((100vw / 16) * 9);
      }
    }
  }
  .cover {
    width: 100vw;
    height: 100vh;
    background: #000;
    opacity: 0.6;
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    z-index: 0;
  }
}
#works {
  .wrapper {
    h2 {
      @media #{$IE} {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        svg {
          height: auto;
          width: 140px;
        }
      }
    }
    .grid-wrapper {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 120px;
      ul {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(calc(50% - 6vw), 0.5fr));
        grid-template-rows: repeat(auto-fit, minmax(auto, 1fr));
        grid-gap: 6vw;
        border-bottom: 0;
        box-sizing: border-box;
        @media #{$maxS} {
          grid-template-columns: repeat(
            auto-fit,
            minmax(calc(100% - 6vw), 1fr)
          );
        }

        li {
          a {
            display: flex;
            flex-flow: column;
            justify-content: flex-start;
            align-items: stretch;
            width: 100%;
            height: 100%;
            @media #{$maxS} {
              margin-bottom: 6px;
            }
          }
          img {
            margin-bottom: 20px;
          }
          h5 {
            line-height: 1.25em;
          }
        }
        @media #{$IE} {
          display: flex;
          flex-flow: row wrap;
          justify-content: space-between;
          align-items: stretch;
          li {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            width: calc(50% - 3vw);
            margin-bottom: 6vw;
            &:nth-last-child(1),
            &:nth-last-child(2) {
              margin-bottom: 0;
            }
            img {
              height: 247px;
            }
          }
        }
      }
    }
  }
}
</style>
